import type { UseCase } from '@/core/shared'
import type { AccessConfigRepository, SubscribeUserToPayPerMonth } from '../domain'

export const subscribeUserToPayPerMonth: UseCase<AccessConfigRepository, 'subscribeUserToPayPerMonth'> = repository => {
  return async (subscribeUserToPayPerMonth: SubscribeUserToPayPerMonth) => {
    await repository.subscribeUserToPayPerMonth(subscribeUserToPayPerMonth)
  }
}
